import { render, staticRenderFns } from "./dialog-add.vue?vue&type=template&id=f2d195f0&scoped=true"
import script from "./dialog-add.vue?vue&type=script&lang=js"
export * from "./dialog-add.vue?vue&type=script&lang=js"
import style0 from "./dialog-add.vue?vue&type=style&index=0&id=f2d195f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d195f0",
  null
  
)

export default component.exports